import { useEffect, useRef } from 'react';
import { howWeWork } from '../../../mocks/libertySoft';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { attachTilt } from '../../../hooks/useTiltCards';
import SectionHeading from '../../../components/base/SectionHeading';

export default function Principles() {
  const revealRef = useScrollReveal<HTMLDivElement>({ stagger: 0.1 });
  const tiltRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!tiltRef.current) return;
    return attachTilt(tiltRef.current, 3);
  }, []);

  return (
    <section
      ref={revealRef}
      id="how-we-work"
      className="relative bg-background-100 text-white py-24 md:py-32 overflow-hidden"
    >
      {/* Background grid */}
      <div className="absolute inset-0 tech-grid tech-grid-mask opacity-20 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-16 md:mb-20">
          <SectionHeading
            title={`Looking Beyond\nBuilt\u00A0on\u00A0logic\nIn it for the long run`}
            description="Three principles that guide how we deploy capital and make decisions."
          />
        </div>

        <div ref={tiltRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {howWeWork.map((p, idx) => (
            <div
              key={p.title}
              className="gsap-reveal tilt-card hover-glow hover-glow-enhanced group relative bg-background-200 rounded-2xl border border-white/5 hover:border-white/15 transition-all duration-500 p-8 md:p-10"
            >
              {/* Large number */}
              <div className="absolute top-6 right-8 text-[100px] md:text-[120px] font-display font-bold text-white/[0.03] leading-none select-none pointer-events-none">
                0{idx + 1}
              </div>

              <div className="relative">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl liquid-glass mb-6 tilt-lift">
                  <i className={`${p.icon} text-xl`}></i>
                </div>

                <h3 className="font-display text-2xl md:text-3xl mb-3">
                  <span className="title-shimmer inline-block">{p.title}</span>
                </h3>

                <p className="text-white/55 text-sm md:text-base leading-relaxed max-w-md">
                  {p.description}
                </p>
              </div>

              {/* Hover bottom accent */}
              <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}